// import searchTranslates from '../section-projects/search-i18n';

export default function () {
  return {
    // ...searchTranslates(),

    breadcrumbsMain: {
      ru: 'Главная',
      ua: 'Головна'
    },
    currencyConverter: {
      ru: 'Конвертер валют',
      ua: 'Конвертер валют'
    },
    currencySale: {
      ru: 'Вы отдаёте',
      ua: 'Ви віддаєте'
    },
    currencyPurchase: {
      ru: 'Вы получаете',
      ua: 'Ви отримуєте'
    },
    purchase: {
      ru: 'Покупка',
      ua: 'Купівля'
    },
    sale: {
      ru: 'Продажа',
      ua: 'Продаж'
    }
  };
}
